export const environment = {
  production: false,
  apiUrl: 'https://crmpre.llibrestext.net/api/v1',
  appName: 'CRM Llibres Text',
};
